import { filterGoals } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useFilteredGoals = () => {
  const user = useUser();
  const goals = useGoals();

  return useMemo(() => {
    const roadmapSettings = user?.settings?.goalsOverview?.roadmap ?? {};

    return filterGoals(goals, {
      hideUnplanned: roadmapSettings.hideUnplannedGoals,
      hideCompleted: roadmapSettings.hideCompletedGoals,
      hideArchived: roadmapSettings.hideArchivedGoals,
    });
  }, [goals, user?.settings?.goalsOverview?.roadmap]);
};
